<template>
  <sdPageHeader :title="title"> </sdPageHeader>
  <Main>
    <HorizontalFormStyleWrap>
      <sdCards headless>
        <a-form
          layout="horizontal"
          :model="formState"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          labelAlign="left"
          :rules="rules"
          @finish="handleSubmit"
        >
          <a-form-item name="file" label="File">
            <div class="clearfix">
              <a-upload :file-list="fileList" :before-upload="beforeUpload" :remove="handleRemove" accept=".zip">
                <a-button>
                  <upload-outlined></upload-outlined>
                  Select File
                </a-button>
              </a-upload>
            </div>
          </a-form-item>

          <a-row>
            <a-col :lg="{ span: 18, offset: 6 }" :md="{ span: 15, offset: 9 }" :xs="{ span: 24, offset: 0 }">
              <div class="sDash_form-action">
                <sdButton
                  type="primary"
                  :disabled="fileList.length === 0"
                  :loading="isLoading"
                  style="margin-top: 16px"
                  htmlType="button"
                  size="large"
                  @click="handleSubmit"
                >
                  {{ isLoading ? 'Harap Menunggu...' : mode }}
                </sdButton>

                <router-link :to="'/nko/rekap'">
                  <sdButton class="sDash_form-action__btn" type="light" size="large" htmlType="button">
                    Batal
                  </sdButton>
                </router-link>
              </div>
            </a-col>
          </a-row>

          <a-row :gutter="25" class="mt-25">
            <a-col :lg="{ span: 18, offset: 6 }" :md="{ span: 15, offset: 9 }" :xs="{ span: 24, offset: 0 }">
              <div v-if="progress > 0">
                <a-progress :value="progress" :percent="progress" status="active"></a-progress>
              </div>
            </a-col>
          </a-row>

          <!-- Confirmation Modal -->
          <a-modal
            v-model:visible="confirmModalVisible"
            title="Konfirmasi Upload"
            :closable="true"
            @cancel="cancelUpload"
            :maskClosable="false"
          >
            <p>
              Apakah Anda yakin ingin mengunggah file ini? Harap tidak menutup halaman atau berpindah ke halaman lain
              sampai proses unggah selesai.
            </p>
            <template #footer>
              <a-button key="back" @click="cancelUpload">Batal</a-button>
              <a-button key="submit" type="primary" :loading="isLoading" @click="confirmUpload">Ya, Unggah</a-button>
            </template>
          </a-modal>
        </a-form>
      </sdCards>
    </HorizontalFormStyleWrap>
  </Main>
</template>

<script>
import { HorizontalFormStyleWrap } from '../../../components/crud/style';
import { Main } from '../../styled';
import { UploadOutlined } from '@ant-design/icons-vue';
import { reactive, watch, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { getItem } from '@/utility/localStorageControl';
import axiosApi from '@/api';
import { notification } from 'ant-design-vue';
import axios from 'axios';

const NkoRekapUploadForm = {
  name: 'NkoRekapUploadForm',
  components: { HorizontalFormStyleWrap, Main, UploadOutlined },
  props: ['mode', 'module'],
  setup() {
    const { params } = useRoute();
    const router = useRouter();
    const fileList = ref([]);
    const uploading = ref(false);

    const progress = ref(0);
    const confirmModalVisible = ref(false);
    const formState = reactive({
      file: null,
    });
    const isLoading = ref(false);
    const dateState = reactive({
      month: params.month,
      year: params.year,
    });

    const handleFileChange = e => {
      formState.file = e.target.files[0];
    };

    const handleSubmit = () => {
      // Show confirmation modal instead of directly uploading
      confirmModalVisible.value = true;
    };

    const cancelUpload = () => {
      confirmModalVisible.value = false;
    };

    const confirmUpload = async () => {
      const entitas = getItem('entitas');
      const month = getItem('bulan');
      const year = getItem('tahun');

      try {
        for (const file of fileList.value) {
          // Step 1: Request pre-signed URL
          axiosApi.defaults.headers.common['Authorization'] = 'Bearer ' + getItem('access_token');

          const res = await axiosApi.post('generate-upload-url', {
            filename: file.name,
            content_type: file.type,
            entitas,
            month,
            year,
          });

          const { upload_url } = res.data;

          // Step 2: Upload file directly to MinIO
          await axios.put(upload_url, file, {
            headers: {
              'Content-Type': file.type,
            },
            onUploadProgress: progressEvent => {
              const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              progress.value = percentCompleted; // Update progress state
              // console.log(`Progress: ${percentCompleted}%`);
            },
          });

          const base_url = upload_url.split('?')[0];
          const path = base_url.split('/evidence-files/')[1];

          await axiosApi.post('insert-evidence', {
            entitas,
            month,
            year,
            title: file.name,
            storage_location: path,
            file_type: file.type,
            file_size: file.size,
          });
        }

        notification.success({
          message: 'File berhasil diunggah',
        });

        fileList.value = [];
        progress.value = 0;
        uploading.value = false;
        isLoading.value = false;
        router.push('/nko/rekap');
      } catch (error) {
        console.error('Error uploading file:', error);
        notification.error({
          message: 'Gagal mengunggah file',
        });
        fileList.value = [];
        progress.value = 0;
        uploading.value = false;
        isLoading.value = false;
      }
    };

    watch(fileList, newFileList => {
      formState.file = newFileList.length > 0 ? newFileList[0].name : null;
    });

    const beforeUpload = file => {
      fileList.value = [file];
      return false;
    };

    const handleRemove = file => {
      const index = fileList.value.indexOf(file);
      if (index !== -1) {
        fileList.value.splice(index, 1);
      }
    };

    return {
      formState,
      dateState,
      isLoading,
      handleSubmit,
      handleFileChange,
      fileList,
      uploading,
      progress,
      handleRemove,
      beforeUpload,
      confirmModalVisible,
      cancelUpload,
      confirmUpload,
    };
  },
  data() {
    return {
      title: this.mode + ' ' + this.module,
      labelCol: {
        lg: 6,
        md: 9,
        xs: 24,
      },
      wrapperCol: {
        lg: 18,
        md: 15,
        xs: 24,
      },
      rules: {
        file: [{ required: true, message: 'File wajib dipilih', trigger: 'change' }],
      },
    };
  },
};

export default NkoRekapUploadForm;
</script>
